import { SurveyRecipientDtoStateEnum } from 'apps/marsinet/src/app/typescript-axios';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';

export const TableRecipients = ({ recipients, loadingRecipients, t }) => (
  <DataTable
    value={recipients}
    loading={loadingRecipients}
    className="p-datatable-striped"
    paginator
    rows={25}
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    currentPageReportTemplate={''}
    rowsPerPageOptions={[10, 25, 50]}
  >
    <Column
      field="user_name"
      header={t('pages.surveys.user_name')}
      body={(rowData) => (
        <span className="text-gray-800">{rowData.user_name}</span>
      )}
    />
    <Column
      field="org_name"
      header={t('pages.surveys.org_name')}
      body={(rowData) => (
        <span className="text-gray-800">{rowData.org_name}</span>
      )}
    />
    <Column
      field="state"
      header={t('pages.surveys.state')}
      body={(rowData) => {
        const stateMap: Record<
          string,
          {
            label: string;
            severity: 'success' | 'info' | 'warning' | 'danger';
          }
        > = {
          [SurveyRecipientDtoStateEnum.Pending]: {
            label: t('pages.surveys.recipient_states.pending'),
            severity: 'warning',
          },
          [SurveyRecipientDtoStateEnum.Answered]: {
            label: t('pages.surveys.recipient_states.answered'),
            severity: 'success',
          },
          [SurveyRecipientDtoStateEnum.Overdue]: {
            label: t('pages.surveys.recipient_states.overdue'),
            severity: 'danger',
          },
        };
        const stateConfig = stateMap[rowData.state] || {
          label: rowData.state,
          severity: 'info' as const,
        };
        return (
          <Tag value={stateConfig.label} severity={stateConfig.severity} />
        );
      }}
    />
    <Column
      field="days_left"
      header={t('pages.surveys.days_left')}
      body={(rowData) => (
        <span className="text-gray-800">
          {rowData.days_left !== null && rowData.days_left !== undefined
            ? rowData.days_left
            : t('noData')}
        </span>
      )}
    />
  </DataTable>
);
